// This file is AUTOGENERATED, do not edit it manually!!!

export const users = {
    active: 'Actief',
    active_switch_description: 'Door de Actief eigenschap van de gebruiker uit te zetten, bereik je twee dingen: je maakt een licentie vrij voor een andere gebruiker en de inactieve gebruiker wordt onzichtbaar in het hele systeem, behalve op de Gebruikers pagina.',
    add_user: 'Gebruiker toevoegen',
    apply: 'Toepassen',
    assign: 'Toevoegen',
    assigned_activities_menu_title: 'Toegewezen activiteiten',
    can_login: 'Kan inloggen',
    can_login_switch_description: 'Door Kan inloggen uit te zetten, ontzeg je de gebruiker alleen toegang tot het systeem. De gebruiker kan nog steeds een projectlid of toegewezen persoon zijn. Door deze actie maak je ook een licentie vrij als je er een nodig hebt.',
    cancel: 'Annuleren',
    CanDenyLogin_User_DenyLoginYourself: 'Je kunt Kan inloggen niet voor jezelf uitzetten.',
    CanDenyLogin_User_LastAdministrator: 'Je kunt Kan inloggen niet uitzetten voor een gebruiker die de enige beheerder in het systeem is.',
    CanDisable_User_DisableYourself: 'Je kunt Actief niet voor jezelf uitzetten.',
    CanDisable_User_LastAdministrator: 'Je kunt Actief niet uitzetten voor een gebruiker die de enige beheerder in het systeem is.',
    cant_delete_user: 'Gebruiker \"{0}\" kan niet worden verwijderd',
    cant_login: 'Kan niet inloggen',
    change_password: 'Wachtwoord wijzigen',
    close: 'Sluiten',
    convert_title: 'Converteren',
    convert_to_regular: 'Converteren naar reguliere gebruiker',
    convert_to_regular_title: '{0} converteren naar een reguliere gebruiker met de rol:',
    convert_to_regular_title_with_job_role: '{0} converteren naar een reguliere gebruiker met de functierol:',
    deactivate: 'Status wijzigen',
    deactivateTitle: 'Gebruikersstatus wijzigen naar Inactief',
    delete: 'Verwijderen',
    delete_confirm: 'Deze gebruiker verwijderen?',
    delete_skill_title: 'Vaardigheid verwijderen',
    delete_team_title: 'Team verwijderen',
    DeleteRateBtnTitle: 'Permanent verwijderen',
    Disable_Permission_Message: 'Je staat op het punt om een machtiging in je rol uit te schakelen waarmee je je eigen en andere gebruikersmachtigingen kunt bewerken.',
    Disable_Permission_Title: 'Je kunt gebruikersmachtigingen niet meer bewerken.',
    DisplayName_customerId: 'Klant',
    DisplayName_email: 'E-mail',
    DisplayName_hourlyRate: 'Uurtarief facturering',
    DisplayName_hourlyRateInternal: 'Intern uurtarief',
    DisplayName_login: 'Inloggen',
    email: 'E-mail',
    exclude: 'Uitsluiten',
    filterbystatus_Active: 'Alleen actieve',
    filterbystatus_All: 'Actieve en inactieve',
    filterbystatus_CannotLogin: 'Alleen kan niet inloggen',
    filterbystatus_Inactive: 'Alleen inactieve',
    generate: 'Genereren',
    guest_portal_title: 'Gastenportaal.',
    guests_interaction: 'Gasten kunnen alleen via interactie met het systeem omgaan via',
    guests_license: 'Ze hebben geen licentie nodig.',
    guests_users_tab_title: 'Gasten',
    import_title: 'Importeren',
    inactive: 'Inactief',
    jobroles_updated_successfully: 'Functierollen zijn succesvol bijgewerkt.',
    lastActivityDate_title: 'Laatst bezocht',
    licensing_limits_warning: 'Je kunt deze gebruiker geen toegang geven omdat je licentie geen extra gebruikers toestaat die kunnen inloggen.',
    name_column_title: 'Naam',
    no_sercurity_logs: 'Deze gebruiker heeft nog geen vermeldingen.',
    password_changed: 'Het wachtwoord is gewijzigd.',
    personal_schedule_title: 'Persoonlijk schema',
    regular_users_tab_title: 'Reguliere',
    reload: 'Vernieuwen',
    remove_confirm: 'Gebruiker verwijderen?',
    reset: 'Toewijzen',
    reset_password_confirmation: 'Door op \"Genereren\" te klikken, wordt er een nieuw wachtwoord gegenereerd en per e-mail naar de gebruiker gestuurd.',
    reset_password_done: 'Er is een nieuw wachtwoord gegenereerd en verstuurd.',
    reset_password_menu_title: 'Wachtwoord genereren en e-mailen',
    reset_password_title: 'Wil je echt het nieuwe wachtwoord genereren en e-mailen?',
    reset_permissions_confirmation: 'Zodra toegewezen, heeft de gebruiker de huidige rol in alle projecten waar deze gebruiker lid van is. De operatie kan niet ongedaan worden gemaakt.',
    reset_permissions_done: 'De huidige rol is toegewezen.',
    reset_permissions_menu: 'Huidige rol toewijzen',
    reset_permissions_title: 'Wil je de huidige rol toewijzen aan alle projecten van de gebruiker?',
    security_logs_action: 'Actie',
    security_logs_date: 'Datum',
    security_logs_modal_title: 'Beveiligingslogboek voor',
    security_logs_title: 'Beveiligingslogboek',
    securitylog_msg_GuestConverted: 'Rol veranderd van Gast naar {0} door {1}.',
    securitylog_msg_LoginChanged: 'Inloggen is veranderd door gebruiker {0}.',
    securitylog_msg_LoginChangedBySelf: 'Inloggen is veranderd.',
    securitylog_msg_PasswordChanged: 'Wachtwoord is veranderd door gebruiker {0}.',
    securitylog_msg_PasswordChangedByRecovery: 'Wachtwoord is hersteld.',
    securitylog_msg_PasswordChangedBySelf: 'Wachtwoord is veranderd.',
    securitylog_msg_PasswordGenerated: 'Wachtwoord is gegenereerd door gebruiker {0}.',
    securitylog_msg_PasswordGeneratedBySelf: 'Wachtwoord is gegenereerd.',
    securitylog_msg_PasswordIncorrect: 'Onjuist wachtwoord.',
    securitylog_msg_RecoveryRequest: 'Herstelverzoek.',
    securitylog_msg_RoleChanged: 'Rol veranderd van {0} naar {1} door {2}.',
    securitylog_msg_UserLockout: 'Gebruiker werd uitgesloten na ongeldige wachtwoordpogingen.',
    securitylog_msg_UserLockoutDueToInactivity: 'Gebruiker werd uitgesloten vanwege inactiviteit.',
    securitylog_msg_UserUnlocked: 'Gebruiker werd ontgrendeld door gebruiker {0}.',
    selected_users: '1#{0} Gebruiker geselecteerd#{0} Gebruikers geselecteerd',
    Set_skills: 'Vaardigheden toevoegen',
    Set_teams: 'Teams',
    show: 'Weergeven',
    show_other_reasons: 'Andere redenen weergeven',
    skills: 'Vaardigheden',
    skills_updated_successfully: 'Vaardigheden zijn succesvol bijgewerkt.',
    skillsDeleteConfirm: 'De vaardigheid wordt verwijderd uit profielen van andere gebruikers waar het wordt gebruikt.',
    spaces: 'Ruimtes',
    suggest_deactivate: 'U heeft echter de optie om de gebruiker inactief te maken, waardoor de zichtbaarheid van de gebruiker in heel {brandName} wordt verwijderd, behalve op de pagina Gebruikers en in de geschiedenis van project- en taaktoewijzing. Deze actie zal een licentie vrijmaken voor een andere gebruiker.',
    teams: 'Teams',
    teams_updated_successfully: 'Teams zijn succesvol bijgewerkt.',
    teamsDeleteConfirm: 'Het team wordt verwijderd uit de teams van elke gebruiker.',
    TimerText: '1#{0} seconde#{0} seconden',
    unlock: 'Ontgrendelen',
    user_conversion_done: '{0} is succesvol geconverteerd.',
    user_conversion_title: 'Gebruiker conversie',
    user_duplicate_email_error: 'Een gebruiker met het opgegeven e-mailadres bestaat al.',
    user_duplicate_login_error: 'Een gebruiker met de opgegeven login bestaat al.',
    user_licensing_limits_warning: 'U kunt Can login niet inschakelen voor deze gebruiker, omdat er geen licentieplaatsen meer beschikbaar zijn.',
    User_NotFound_Title: 'Aangevraagde gebruiker niet gevonden',
    userRates: 'Tariefgeschiedenis',
    userRates_changed_by: 'Gewijzigd door',
    userRates_date: 'Datum van wijziging',
    userRates_hourlyRate: 'Facturatie-uurtarief',
    userRates_hourlyRateInternal: 'Intern uurtarief',
    userRates_title: 'Tariefgeschiedenis voor {0}',
};
